export default "__VITE_ASSET__Czy1CYK___"